import { AbstractLookupStore } from "../common/AbstractStores";
import Dispatcher from "../common/dispatcher";
import Actions from "./ReportsActions";
import { ImpiantoReport } from "../generated";

class PlantsReplacementsReportStore extends AbstractLookupStore<ImpiantoReport>{
    constructor() {
        super();
        Dispatcher
            .onfunction(Actions.getPlantForReplacementsCampaign, result => this.set(result.minYears.toString(), result.report))
            ;
    }

    public useWithMinYear = (minYear: number) => this.useStoreWithAction(minYear.toString(), key => Actions.getPlantForReplacementsCampaign(+key));
}

export default new PlantsReplacementsReportStore()
